
import LoanDetails from "./LoanDetails.vue";
import LoanList from "./LoanList.vue";
import { Loan, LoanStatus } from "@/models/Loan";
import Notify from 'quasar/src/plugins/Notify.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';;
import { onMounted, watch } from "vue";
import { ref } from "@vue/reactivity";
import { useLoan } from "@/hooks/useLoan";
export default {
  components: { LoanDetails, LoanList },
  setup() {
    const { loanData, updateStatus } = useLoan({});
    const selectedFilter = ref(LoanStatus.PendingApproval);
    const selectedLoan = ref<Loan>();
    const filteredList = ref([...loanData.value]);
    const showLoan = ref(false);
    const dialogRef = ref<QDialog>();
    const handleLoanClick = (loan) => {
      selectedLoan.value = loan;
      showLoan.value = true;
    };

    const filterOptions = [
      LoanStatus.PendingApproval,
      LoanStatus.Approved,
      LoanStatus.Active,
      LoanStatus.Rejected,
      LoanStatus.Completed,
    ];
    const updateFilteredList = (status = selectedFilter.value) => {
      filteredList.value = loanData.value.filter(
        (loan) => loan.status === status
      );
    };
    onMounted(() => updateFilteredList());

    const updateStatusAndFilterLoanList = (status: string) => {
      const successMessage =
        status === LoanStatus.Approved ? "Loan Approved!" : "Loan Rejected!";
      updateStatus(selectedLoan?.value?.id as number, status).then(
        (response) => {
          if (response) {
            updateFilteredList();
            dialogRef?.value?.hide();
            Notify.create({
              message: successMessage,
              color: "primary",
              icon: "check_circle",
            });
          }
        }
      );
    };
    watch(selectedFilter, (selectedStatus) =>
      updateFilteredList(selectedStatus)
    );

    return {
      dialogRef,
      filteredList,
      filterOptions,
      handleLoanClick,
      loanData,
      LoanStatus,
      selectedFilter,
      selectedLoan,
      showLoan,
      updateStatus,
      updateStatusAndFilterLoanList,
    };
  },
};
